import { getTestId } from '@airtel/air-design-system';
var expandCtaData = {
  expandedCtaTitle: 'View More',
  collapseCtaTitle: 'Show Less',
  initialItemCount: 2,
  expandedIconName: 'DownChevronButtonIcon',
  collapseIconName: 'UpChevronButtonIcon'
};
export var defaultProps = Object.assign({
  cardTitle: 'CHANGES THIS MONTH',
  list: [{
    singleListTitle: 'POSTPAID',
    singleListSubTitle: '• 8130029344',
    id: 'ScrollListContainer',
    showExpandCta: true,
    expandCtaData: expandCtaData,
    data: Array.from({
      length: 2
    }, () => ({
      avatarIcon: 'UpArrowIcon',
      title: 'DD MM YYYY',
      heading: '₹Price/heading text',
      subHeading: 'Bi-line descriptions comes here in this place',
      indicatorType: 'none',
      actionType: 'button',
      actionTypeProps: {
        buttonText: 'BUTTON',
        value: 'BUTTON',
        label: 'BUTTON',
        onPress: {
          id: 'postpaid',
          actions: []
        }
      },
      indicatorPosition: 'center'
    }))
  }, {
    singleListTitle: 'XSAFE',
    singleListSubTitle: '• 8130029344',
    id: 'ScrollListContainer',
    showExpandCta: true,
    expandCtaData: expandCtaData,
    ctaOnContainerTitle: 'Add New Connections',
    data: Array.from({
      length: 2
    }, () => ({
      avatarIcon: 'UpArrowIcon',
      title: 'DD MM YYYY',
      heading: '₹Price/heading text',
      subHeading: 'Bi-line descriptions comes here in this place',
      actionType: 'button',
      indicatorType: 'none',
      actionTypeProps: {
        buttonText: 'BUTTON',
        onPress: {
          id: 'xsafe',
          actions: []
        }
      },
      indicatorPosition: 'center'
    }))
  }]
}, getTestId('BillingListWidgetContainer'));